import { Badge } from '/@/modules/core/nav/models/Badge';
import { NavItemGroup } from '/@/modules/core/nav/models/NavItemGroup';
import { NavKey } from '/@/modules/core/nav/constants/NavKey';
import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class NavItem extends BaseModel {
  /**
   * @var {string}
   */
  title;

  /**
   * @var {string}
   */
  subtitle;

  /**
   * @var {string}
   */
  compactTitle;

  /**
   * @var {string}
   */
  icon;

  /**
   * @var {?string}
   */
  link;

  /**
   * @var {string}
   */
  tooltip;

  /**
   * @var {boolean}
   */
  disabled;

  /**
   * @var {boolean}
   */
  hiddenInMobile;

  /**
   * @var {boolean}
   */
  exactMatch;

  /**
   * @var {object}
   */
  attributes;

  /**
   * @var {NavItem[]}
   */
  children;

  /**
   * @var {string}
   */
  key;

  /**
   * @var {?Vue.Component|?string}
   */
  customComponent;

  /**
   * @var {string}
   */
  customBadge;

  /**
   * @var {boolean}
   */
  isLocked;

  /**
   * @var {string}
   */
  dataGuideKey;

  /**
   * @var {?NavItemGroup}
   */
  group;

  constructor(model = {}) {
    super();

    this.title = model.title;
    this.subtitle = model.subtitle;
    this.compactTitle = model.compactTitle;
    this.icon = model.icon;
    this.link = model.link;
    this.tooltip = model.tooltip;
    this.disabled = model.disabled;
    this.hiddenInMobile = model.hiddenInMobile;
    this.exactMatch = model.exactMatch;
    this.attributes = Array.isArray(model.attributes) || !model.attributes ? {} : model.attributes;
    this.children = model.children && model.children.map((child) => new NavItem(child));
    this.badge = model.badge && new Badge(model.badge);
    this.customBadge = model.customBadge;
    this.isLocked = model.isLocked;
    this.key = model.key;
    this.customComponent = this.getCustomComponent(model);
    this.dataGuideKey = model.dataGuideKey;
    this.group = NavItemGroup.mapModelOrNull(model.group);
  }

  setBadgeText(text) {
    this.badge.text = text;
  }

  get hasChildren() {
    return !!this.children?.length;
  }

  /**
   * @param item
   * @returns {?string}
   */
  getCustomComponent(item) {
    switch (item.key) {
      case NavKey.NAV_GIVE_FEEDBACK:
        return 'GiveFeedbackNavItem';
      case NavKey.NAV_INBOX:
        return 'InboxNavItem';
      case NavKey.NAV_NOTIFICATIONS:
        return 'NotificationsNavItem';
      case NavKey.NAV_TOOLS:
        return 'ToolsNavItem';
      case NavKey.NAV_ADVISOR_PRO_UPGRADE:
        return 'FinancialAdvisorAdvisorProUpgradeNavItem';
      case NavKey.NAV_TEAMS_DROPDOWN:
        return 'TeamDropdownNavItem';
      default:
        return null;
    }
  }
}
